import createReactContext from 'create-react-context';
import defaultTheme from '@hig/theme-data/build/json/lightGrayMediumDensityTheme/theme.json';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var _createReactContext = createReactContext(defaultTheme),
    Provider = _createReactContext.Provider,
    Consumer = _createReactContext.Consumer;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isPresent(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function hasRoleFormat(prop) {
  return prop.search(/\./) > 0;
}

function resolvedRolesProxy(roles, theme) {
  if ((typeof roles === "undefined" ? "undefined" : _typeof(roles)) !== "object") return roles;

  return new Proxy(roles, {
    get: function get(obj, prop) {
      if (hasRoleFormat(prop) && !isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error("Role " + prop.toString() + " does not exist");
        return obj[prop];
      }

      var hasRoleDeprecationInfo = isPresent(theme, "metadata") && isPresent(theme.metadata, "__deprecated__") && isPresent(theme.metadata.__deprecated__, prop);

      if (hasRoleDeprecationInfo) {
        var roleDeprecationInfo = theme.metadata.__deprecated__[prop];

        var equivalencyInfo = roleDeprecationInfo.equivalent ? " and has been renamed to " + roleDeprecationInfo.equivalent.toString() + "." : ".";

        /* eslint-disable-next-line no-console */
        console.warn("Role " + prop.toString() + " is deprecated" + equivalencyInfo);
      }

      return obj[prop];
    }
  });
}

function createThemeProxy(theme) {
  return new Proxy(theme, {
    get: function get(obj, prop) {
      var value = obj[prop];

      if (prop.toString() === "resolvedRoles") return resolvedRolesProxy(value, theme);

      if (!isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error("Property " + prop.toString() + " does not exist.");
        return value;
      }

      if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value !== null) return createThemeProxy(value);

      return value;
    }
  });
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Consumer$1 = function (_Component) {
  _inherits(Consumer$$1, _Component);

  function Consumer$$1() {
    _classCallCheck(this, Consumer$$1);

    return _possibleConstructorReturn(this, (Consumer$$1.__proto__ || Object.getPrototypeOf(Consumer$$1)).apply(this, arguments));
  }

  _createClass(Consumer$$1, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(
        Consumer,
        null,
        function (theme) {
          var isDebugging = process.env.NODE_ENV !== "production";
          var result = isDebugging ? createThemeProxy(theme) : theme;

          return _this2.props.children(result);
        }
      );
    }
  }]);

  return Consumer$$1;
}(Component);

Consumer$1.propTypes = {
  /** A theme provided to the consumer within */
  children: PropTypes.func
};
Consumer$1.__docgenInfo = {
  "description": "",
  "displayName": "Consumer",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A theme provided to the consumer within"
    }
  }
};

var index = { Provider: Provider, Consumer: Consumer$1 };

export default index;
export { index as ThemeContext };
